import { isFulfilled } from '@reduxjs/toolkit'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'

import { resetAllModifiedDataByKey } from 'cng-common/features/form'
import { changeQBRLastStep, selectQBREntryId } from 'partner360/features/QBR'
import { requestQbrDocument } from 'partner360/features/QBR/api/requestQbrDocument'
import { requestQbrDocumentPartners } from 'partner360/features/QBR/api/requestQbrDocumentPartners'

import { QBR_SETTINGS_FORM_KEY } from '../components/steps/settingsStep/components/qbrSettingsForm'

export const useRefreshing = () => {
  const [isRefreshingProgress, setIsRefreshingProgress] = useState(false)
  const qbrDocumentId = useSelector(selectQBREntryId)
  const dispatch = useAppDispatch()

  const refresh = useCallback(async () => {
    if (qbrDocumentId) {
      dispatch(changeQBRLastStep(1))
      setIsRefreshingProgress(true)
      dispatch(resetAllModifiedDataByKey(QBR_SETTINGS_FORM_KEY))
      const requestQbrDocumentAction = await dispatch(
        requestQbrDocument({ documentId: qbrDocumentId, isForceUpdate: true })
      )
      if (isFulfilled(requestQbrDocumentAction)) {
        const { document: qbrDocument } = requestQbrDocumentAction.payload

        if (qbrDocument) {
          await dispatch(
            requestQbrDocumentPartners({
              entryId: qbrDocumentId,
              partnerIds: qbrDocument.PartnerIDs,
              fYear: qbrDocument.FYear,
              settings: qbrDocument.Settings,
              rtm: qbrDocument.RTM,
            })
          )
        }
      }
      setIsRefreshingProgress(false)
    }
  }, [qbrDocumentId, dispatch])

  return { isRefreshingProgress, refresh }
}
